import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { cssVariables } from '@afarinesh/luma-store-ui-kit';
import { extraVars } from './pos/kitVars';
import { App } from './App';
import './styles/global.css';
import './styles/fonts.css';
import './pos/tokens.css';

// Inject the design tokens once, at the root. Every surface reads colours and
// spacing from these custom properties rather than importing the TS objects,
// so plain CSS and inline styles stay in sync with the kit.
const tokenStyle = document.createElement('style');
tokenStyle.textContent = cssVariables() + extraVars();
document.head.appendChild(tokenStyle);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The agent is on loopback: it is either there or it is not, and a
      // retry storm against a dead local service just burns battery on a
      // low-end tablet. Real resilience lives in the agent's sync engine.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
